import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Permis from "../../assets/images/permisos.png";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  createUser,
  getUserList,
  resetPasswordConfirm,
  userEnableDisable,
  userInsertInToGroup,
} from "../../apis/apiUsers";
import { Col, Row, FormCheck } from "react-bootstrap";
import { MCButton } from "../MainComponents/Button/Button";
import { MCSelectSome } from "../MainComponents/SelectSome/SelectSome";
import { EGCheckbox } from "../MainComponents/Checkbox/EGCheckbox";
import { EGInput } from "../MainComponents/Input/EGInput";

import { GeneralIconHeader } from "../Title/GeneralHeader";
import { BoldFlag } from "../Icon";
import { useTranslation } from "react-i18next";

import useLocalizedLabel from "../../hooks/useLocalizedLabel";

import {
  alpha,
  Autocomplete,
  Box,
  Chip,
  Collapse,
  Grid2,
  LinearProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CheckIcon, CloseIcon } from "../Icon";

import { getListGroupEAM, updateUserAdvanceOptions } from "../../apis/apiEAM";
import { assignRoleToUser, getListRoles } from "../../apis";

import { catalogByPart } from "../../apis";
import { MCSelect } from "../MainComponents/Select/Select";
import { SingleRowTextLoading } from "../Loading/SingleRowText/SingleRowText";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { Breadcrum } from "../MainComponents/Breadcrumb/Breadcrumb";
import "./styles.scss";
import { useDispatch } from "react-redux";
import { startGettingUserInfo } from "../../store/auth/authThunks";
import { validEGPassword } from "../../helpers/validPassword";
import { EGBasicSelect } from "../MainComponents/Select/EGBasicSelect";
import { set } from "lodash";

const showSnackBar = (msg, type = "error") => {
  enqueueSnackbar(`${msg}`, {
    variant: type,
    autoHideDuration: 3000,
  });
};

const AssignRole = ({ userId, currentRole }) => {
  const [rolesList, setRolesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [t] = useTranslation("users");

  useEffect(() => {
    setIsLoading(true);
    getListRoles().then((resp) => {
      setRolesList(resp.response);
      if (currentRole !== null && Array.isArray(resp.response)) {
        const currentRoleToState = resp.response.find(
          (item) => item.id === currentRole
        );
        setSelectedRole(currentRoleToState);
      }
      setIsLoading(false);
    });
  }, []);

  const handleSubmit = () => {
    if (!selectedRole) {
      showSnackBar(t("User.must_select_role"));
      return;
    }
    assignRoleToUser({ user_id: userId, role_id: selectedRole }).then(
      (resp) => {
        showSnackBar(t("User.user_role_updated"), "success");
      }
    );
  };

  return (
    <>
      <h5 className="mb-20">{t("User.assign_user_role")}</h5>
      <div className="d-flex justify-content-beetween align-items-center">
        <div className="w-100">
          {!isLoading && Array.isArray(rolesList) && (
            <EGBasicSelect
              label={t("User.assign_user_role")}
              options={rolesList}
              optionLabel="name"
              optionValue="id"
              value={selectedRole ?? ""}
              onChange={(e) => setSelectedRole(Number(e.target.value))}
            />
          )}
        </div>
        <MCButton
          label={t("User.assign")}
          variant="primary"
          className="ms-2"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};

export const returnStringOfSelections = async (
  string,
  catalogue,
  is_own,
  value,
  nestNum = 0,
  forEdition = true
) => {
  try {
    let newString = string;
    const splitedAnsr = value.split("::");
    const slicedAnsr = splitedAnsr.slice(0, 2 * nestNum);
    const joined = slicedAnsr.join("::");
    const slicedAnsrKey = splitedAnsr.slice(nestNum * 2, 2 * (nestNum + 1));
    const selected =
      slicedAnsrKey.length === 2 ? slicedAnsrKey[slicedAnsrKey.length - 1] : "";
    const resp = await catalogByPart({
      is_own,
      catalogue,
      path: joined ? joined : "/",
      ...(forEdition && { show_all: true }),
    });
    if (resp.error) throw new Error("Error at getting chain of selections");
    if (selected) {
      const newResp = resp.data.find((item) => item.key == selected);
      newString = newString
        ? `${newString} > ${newResp?.label}`
        : `${newResp?.label}`;
      return returnStringOfSelections(
        newString,
        catalogue,
        is_own,
        value,
        nestNum + 1,
        forEdition
      );
    } else {
      return string;
    }
  } catch (error) {}
};

const AddSegment = ({
  segmentList,
  currentSegments = [],
  setGroupSegment,
  userId,
  onLoadSegments,
}) => {
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [isActive, setIsActive] = useState(false);

  const [t] = useTranslation("users");

  const handleAddSegment = async (id) => {
    try {
      await userInsertInToGroup({
        user_id: userId,
        group_list: [...currentSegments, selectedSegment.id],
      });
      setGroupSegment([...currentSegments, selectedSegment.id]);
      setSelectedSegment(null);
      setIsActive(false);
    } catch (error) {}
  };

  const handleCancelAdd = () => {
    setSelectedSegment(null);
    setIsActive(false);
  };

  return (
    <>
      {isActive ? (
        <>
          <h5 className="mb-20">{t("User.add_access_filter_group")}</h5>
          <div>
            <div className="d-flex">
              <EGBasicSelect
                value={selectedSegment?.id ?? ""}
                onChange={(event) => {
                  const selectedId = event.target.value;
                  const fullSegment = segmentList.find(
                    (seg) => seg.id === selectedId
                  );
                  setSelectedSegment(fullSegment || null);
                }}
                options={segmentList?.filter(
                  (segm) => !currentSegments.includes(segm.id)
                )}
                optionLabel="name"
                optionValue="id"
                placeholder="Selecciona un segmento"
              />

              <div className="d-flex">
                {selectedSegment && (
                  <MCButton
                    label={t("User.add")}
                    variant="primary"
                    className="me-1"
                    onClick={handleAddSegment}
                  />
                )}
                <MCButton
                  label={t("User.cancel")}
                  variant="danger"
                  onClick={handleCancelAdd}
                />
              </div>
            </div>
            {selectedSegment && (
              <div className="d-flex flex-column">
                <h5 className="text-center my-3">{t("User.access_preview")}</h5>
                <Segment segment={selectedSegment.segment} />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="d-flex justify-content-between">
          <h5>{t("User.add_access_filter_group")}</h5>
          <MCButton
            label="+"
            variant="primary"
            onClick={() => {
              if (onLoadSegments) onLoadSegments();
              setIsActive(true);
            }}
          />
        </div>
      )}
    </>
  );
};

const Segment = ({ segment, nestLvl = 0 }) => {
  const [recursiveSegments, setRecursiveSegments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    mount();
  }, [segment]);

  const mount = async () => {
    setIsLoading(true);
    if (nestLvl === 0) {
      const tempScopeSeg = Object.entries(segment);
      const newSegments = tempScopeSeg.map(async (item) => {
        const splitedKey = item[0].split("::");
        const is_own = splitedKey[1] === "OWN" ? true : false;
        const catalogue = splitedKey[2];
        const value = [];
        if (Array.isArray(item[1].value)) {
          for (const val of item[1].value) {
            const valTemp = await returnStringOfSelections(
              "",
              catalogue,
              is_own,
              val
            );
            value.push(valTemp);
          }
        }
        return { label: item[1].label, child: item[1].child, value };
      });
      const ultimateSegments = await Promise.all(newSegments);
      setRecursiveSegments(ultimateSegments);
      setIsLoading(false);
    } else {
      const newSegments = segment.map(async (item) => {
        const splitedKey = item.field.split("::");
        const is_own = splitedKey[1] === "OWN" ? true : false;
        const catalogue = splitedKey[2];
        const value = [];
        if (Array.isArray(item.value)) {
          for (const val of item.value) {
            const valTemp = await returnStringOfSelections(
              "",
              catalogue,
              is_own,
              val
            );
            value.push(valTemp);
          }
        }
        return { label: item.label, child: item.child, value };
      });
      const ultimateSegments = await Promise.all(newSegments);
      setRecursiveSegments(ultimateSegments);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <>
        <SingleRowTextLoading className="my-1" />
        <SingleRowTextLoading className="my-1" />
        <SingleRowTextLoading className="my-1" />
      </>
    );
  }

  return (
    <>
      {recursiveSegments.map((item, idx) => (
        <div key={idx} className={`${nestLvl > 0 ? "ms-3" : ""}`}>
          <h6 className="mb-0">{item.label}</h6>
          <div className="mb-2">
            {Array.isArray(item.value) &&
              item.value.map((item2, idx2) => (
                <small key={idx2}>
                  <small>{item2}</small>
                </small>
              ))}
          </div>
          {Array.isArray(item.child) && (
            <Segment segment={item.child} nestLvl={nestLvl + 1} />
          )}
        </div>
      ))}
    </>
  );
};


const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const getPasswordRequirements = (password, t) => [
  { label: t("User.password_minimum"), met: password.length >= 12 },
  { label: t("User.password_number"), met: /[0-9]/.test(password) },
  { label: t("User.password_capital_letter"), met: /[A-Z]/.test(password) },
  { label: t("User.password_symbol"), met: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password) },
];

const getStrength = (password, t) => {
  const requirements = getPasswordRequirements(password, t);
  const metCount = requirements.filter(r => r.met).length;
  if (password.length === 0) return { label: t("User.password_strength_waiting"), color: "grey", value: 0 };
  if (metCount <= 1) return { label: t("User.password_strength_weak"), color: "error", value: 25 };
  if (metCount === 2) return { label: t("User.password_strength_medium"), color: "warning", value: 50 };
  if (metCount === 3) return { label: t("User.password_strength_medium"), color: "warning", value: 75 };
  return { label: t("User.password_strength_strong"), color: "success", value: 100 };
};

const SecurityInformationSection = ({
  email,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  isExistingUser,
  strength,
  requirements,
}) => {
  const [t] = useTranslation("users");
  const { enqueueSnackbar } = useSnackbar();

  const [isActiveForgotPassword, setIsActiveForgotPassword] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState("");

  const handleSendCode = async () => {
    setIsActiveForgotPassword(true);

    // try {
    //   //const resp = await sendCodeResetPassword(email);
    //   setIsActiveForgotPassword(true);
    //   enqueueSnackbar(t("User.code_sent_email"), {
    //     variant: "success",
    //   });
    // } catch (error) {
    //   enqueueSnackbar(t("User.error_trying_send_confirmation_code"), {
    //     variant: "error",
    //   });
    // }
  };

  const handleResetPassword = async () => {
    if (password === "" || confirmPassword === "") {
      enqueueSnackbar(t("User.password_must_not_empty"), {
        variant: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      enqueueSnackbar(t("User.password_no_match"), {
        variant: "error",
      });
      return;
    }
    if (!validEGPassword(password)) {
      enqueueSnackbar(t("User.password_must_contain"), {
        variant: "error",
      });
      return;
    }
    // if (confirmationCode.trim() === "") {
    //   enqueueSnackbar(t("User.invalid_confirmation_code"), {
    //     variant: "error",
    //   });
    //   return;
    // }
    try {
      const resp = await resetPasswordConfirm(email, password, confirmPassword);
      enqueueSnackbar(t("User.password_changed"), {
        variant: "success",
      });
      setIsActiveForgotPassword(false);
    } catch (error) {
      enqueueSnackbar(t("User.error_trying_reset_password"), {
        variant: "error",
      });
    }
  };

  const handleCancelResetPassword = () => {
    setIsActiveForgotPassword(false);
    setConfirmationCode("");
    setPassword("");
    setConfirmPassword("");
  };

  return (
    <section className={`dyTheme1 dyBorder1 rounded p-4 ${isExistingUser ? 'mt-4' : 'h-100'}`}>
      <header className="d-flex justify-content-between">
        <h5 className={isActiveForgotPassword ? "mb-20" : "mb-2"}>
          {isExistingUser ? t("User.security_information") : t("User.security_information")}
        </h5>
        {isExistingUser && !isActiveForgotPassword && (
          <em className="forgot-password-text" onClick={handleSendCode}>
            {t("User.forgot_password")}
          </em>
        )}
      </header>

      {(!isExistingUser || isActiveForgotPassword) && (
        <form>
          <Row>
            <Col md="6" className="mb-2">
              <EGInput
                type="password"
                label={t("User.password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* Barra de seguridad - visible solo al escribir */}
              {password.length > 0 && (
                <Box sx={{ mt: 1, mb: 1 }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <Typography variant="caption">{t("User.security_label")}</Typography>
                    <Chip
                      label={strength.label}
                      size="small"
                      color={strength.color === "grey" ? "default" : strength.color}
                      sx={{ fontSize: '11px', height: '22px', fontWeight: 600 }}
                    />
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    value={strength.value}
                    color={strength.color === "grey" ? "inherit" : strength.color}
                    sx={{ height: 6, borderRadius: 3 }}
                  />
                </Box>
              )}
              {/* Lista de requisitos de contraseña - siempre visible */}
              <Box sx={{ mt: 1 }}>
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    p: 0,
                    m: 0,
                    '& li': {
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      py: 0.5,
                      fontSize: '13px',
                    }
                  }}
                >
                  {requirements.map((req, i) => (
                    <Box
                      component="li"
                      key={i}
                      sx={{
                        color: req.met ? 'success.main' : 'text.disabled',
                        transition: 'color 0.2s ease',
                      }}
                    >
                      {req.met ? (
                        <CheckIcon size={25} color="#4caf50" />
                      ) : (
                        <CheckIcon size={25} color="#9e9e9e" />
                      )}
                      {req.label}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Col>
            <Col md="6" className="mb-2">
              <EGInput
                type="password"
                label={t("User.confirm_password")}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {/* Validación de coincidencia de contraseñas - visible solo al escribir */}
              {confirmPassword.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Box
                    component="ul"
                    sx={{
                      listStyle: 'none',
                      p: 0,
                      m: 0,
                      '& li': {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        py: 0.5,
                        fontSize: '13px',
                      }
                    }}
                  >
                    <Box
                      component="li"
                      sx={{
                        color: password === confirmPassword
                          ? 'success.main'
                          : 'error.main',
                        transition: 'color 0.2s ease',
                      }}
                    >
                      {password === confirmPassword ? (
                        <CheckIcon size={25} color="#4caf50" />
                      ) : (
                        <CloseIcon size={25} color="#f44336" />
                      )}
                      {password === confirmPassword
                        ? t("User.password_match")
                        : t("User.password_no_match")
                      }
                    </Box>
                  </Box>
                </Box>
              )}
            </Col>
          </Row>
          {isActiveForgotPassword && (
            <>
              <Row>
                <Col className="d-flex justify-content-end">
                  <MCButton
                    label={t("User.change_password")}
                    className="me-2"
                    outline
                    variant="primary"
                    onClick={handleResetPassword}
                  />
                  <MCButton
                    label={t("User.cancel")}
                    outline
                    variant="danger"
                    onClick={handleCancelResetPassword}
                  />
                </Col>
              </Row>
            </>
          )}
        </form>
      )}
    </section>
  );
};

export const User = () => {
  const dispatch = useDispatch();
  // const [t] = useTranslation("users");
  const { enqueueSnackbar } = useSnackbar();

  const updateUserOnStore = () => {
    dispatch(startGettingUserInfo());
  };

  // => Component that returns a list of errors when the request failed (shows in modal)
  const Errors = ({ errors }) => {
    const getInput = (key) => {
      if (key === "email") return "Email";
      if (key === "password") return t("User.password");
      return "General";
    };

    return (
      <>
        {Array.isArray(errors) &&
          errors.map((item) => (
            <h4>
              {getInput(item[0])}: {item[1]}
            </h4>
          ))}
        {typeof errors === "string" && <h4>{errors}</h4>}
      </>
    );
  };

  // => Runs when press AddUser button
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validación de campos obligatorios
    if (first_name.trim() === "") {
      enqueueSnackbar(t("User.name_required"), { variant: "error" });
      return;
    }
    if (last_name.trim() === "") {
      enqueueSnackbar(t("User.lastname_required"), { variant: "error" });
      return;
    }
    if (email.trim() === "" || !validateEmail(email)) {
      enqueueSnackbar(t("User.email_required"), { variant: "error" });
      return;
    }
    if (confirmEmail.trim() === "") {
      enqueueSnackbar(t("User.confirm_email_required"), { variant: "error" });
      return;
    }
    if (email !== confirmEmail) {
      enqueueSnackbar(t("User.email_no_match"), { variant: "error" });
      return;
    }
    if (password === "" || confirmPassword === "") {
      enqueueSnackbar(t("User.password_must_not_empty"), {
        variant: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      enqueueSnackbar(t("User.password_no_match"), { variant: "error" });
      return;
    }
    if (!validEGPassword(password)) {
      enqueueSnackbar(t("User.password_must_contain"), { variant: "error" });
      return;
    }
    try {
      const data = await createUser({
        email,
        confirmEmail,
        password,
        first_name,
        last_name,
        username,
        phone_number,
      });
      MySwal.fire({
        title: t("User.user_successfully_created"),
        icon: "success",
        buttonsStyling: true,
        confirmButtonText: t("User.continue"),
        showConfirmButton: true,
        width: "50%",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        stopKeydownPropagation: false,
        confirmButtonColor: "#009ED7",
        customClass: {
          icon: "icon-sweet",
          confirmButton: "btn-sweet",
        },
      });
      navigate("/users");
    } catch (error) {
      MySwal.fire({
        icon: "warning",
        confirmButtonText: t("User.close"),
        showConfirmButton: true,
        width: "50%",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        stopKeydownPropagation: false,
        confirmButtonColor: "#009ED7",
        html: <Errors errors={error.message} />,
        customClass: {
          confirmButton: "btn-sweet",
        },
      });
    }
  };

  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const MySwal = withReactContent(Swal);
  //-- Value of every input --//
  const { t, i18n } = useTranslation("users");
  const lang = i18n.language || "es";
  const [userv, setUserv] = useState("");
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const strength = getStrength(password, t);
  const requirements = getPasswordRequirements(password, t);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [username, setUsername] = useState("");
  const [policy, setPolicy] = useState({
    deny: { status: [], locked: false, severity: false },
  });
  const [phone_number, setPhone_number] = useState("");
  const [groupSegment, setGroupSegment] = useState([]);
  const [role, setRole] = useState(null);
  const [isActive, setIsActive] = useState(null);
  //-- Variable for control, if this component is used to edit a user, this variable get true value, otherwise it stay false --//
  const [isExistingUser, setIsExistingUser] = useState(false);
  //-- Existing segment groups --//
  const [listSegments, setListSegments] = useState([]);
  // Color tags
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const getLocalizedLabel = useLocalizedLabel();

  const theme = useTheme();
  const esXs = useMediaQuery(theme.breakpoints.down("md"));

  const [locked, setLocked] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [reportView, setReportView] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isLoading, setIsLoading] = useState({
    enableDisable: false,
    fetchingUser: false,
  });
  const [userDataFromApi, setUserDataFromApi] = useState(null);
  const [showSegmentUser, setShowSegmentUser] = useState(false);
  const [showSegmentGroup, setShowSegmentGroup] = useState(false);
  const [segmentsLoaded, setSegmentsLoaded] = useState(false);
  const [loadingSegments, setLoadingSegments] = useState(false);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

  const handleTagsChange = (newValue) => {
    setSelectedTags(newValue); // actualizas el estado
    const selectedKeys = newValue.map((opt) => opt.key);
  };

  // const toggleShowMore = () => {
  //   setShowSegmentGroup((prev) => !prev);
  // }

  useEffect(() => {
    const fetchUserById = async () => {
      if (!id) return;
      setIsLoading((prev) => ({ ...prev, fetchingUser: true }));
      try {
        const response = await getUserList();
        const usersList = response?.response || response?.users;
        if (usersList) {
          const foundUser = usersList.find((u) => String(u.id) === String(id));
          if (foundUser) {
            setUserDataFromApi(foundUser);
          }
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      } finally {
        setIsLoading((prev) => ({ ...prev, fetchingUser: false }));
      }
    };

    if (id) {
      setIsExistingUser(true);
      setUserId(id);
      fetchUserById();
    }

    const fetchData = async () => {
      try {
        const resp = await catalogByPart({
          is_own: false,
          catalogue: "TG-100",
          path: "/",
        });
        if (resp.error) {
          console.error("Error in API response:", resp);
          return;
        }
        setTags(resp.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [id]);

  // Loops through the array of tag objects and builds a new
  const transformedType = useMemo(() => {
    return tags.reduce((acc, tag) => {
      acc[tag.key] = tag;
      return acc;
    }, {});
  }, [tags]);

  const indicatorTags = useMemo(() => {
    return tags.map((tag) => ({
      ...tag,
      label: getLocalizedLabel(tag),
      color: tag.key, // Aquí puedes agregar lógica si hay un color asociado
    }));
  }, [tags, lang]);

  // Set variables if is an existing user
  useEffect(() => {
    const userData = state?.user || userDataFromApi;

    if (userData) {
      setUserv(userData);
      setUserId(userData.id);
      setEmail(userData.email);
      setConfirmEmail(userData.confirm_email);
      setFirst_name(userData.first_name);
      setLast_name(userData.last_name);
      setUsername(userData.username);
      setPhone_number(userData.phone_number);
      setGroupSegment(userData.group || []);
      setIsActive(userData.is_active || false);

      if (!userData.policy || Object.keys(userData.policy).length === 0) {
        setPolicy({
          deny: {
            status: [],
            locked: false,
            severity: false,
            reportview: false,
          },
        });
      } else {
        setPolicy(userData.policy || { deny: {status: [], locked: false, severity: false, reportview: false} });
      }

      setRole(userData.role);
      setIsExistingUser(true);

      setLocked(userData.policy?.deny?.locked || false);
      setSeverity(userData.policy?.deny?.severity || false);
      setReportView(userData.policy?.deny?.reportview || false);

      if (userData.policy?.deny?.status?.length >= 1) {
        var list_status = [];
        userData.policy.deny?.status.forEach((item) => {
          if (item !== null || item !== undefined) {
            list_status.push(listStatusDict[item]);
          }
        });
        setSelectedStatus(list_status);
      } else {
        setSelectedStatus(userData.policy?.deny?.status || []);
      }
    }
  }, [state, userDataFromApi]);

  useEffect(() => {
  const userData = state?.user || userDataFromApi;

  if (userData?.policy?.deny?.tags && indicatorTags.length > 0) {
    const existingTagKeys = userData.policy.deny.tags;

    // Se buscan objetos completos dentro de indicatorTags que coincidan con las llaves guardadas
    const defaultSelected = indicatorTags.filter((tag) =>
      existingTagKeys.includes(tag.key)
    );

    setSelectedTags(defaultSelected);
  }
}, [indicatorTags, userDataFromApi, state?.user]); 

  // Load segments on demand (lazy loading)
  const loadSegments = async () => {
    if (segmentsLoaded) return;
    if (loadingSegments) return;
    setLoadingSegments(true);
    try {
      const resp = await getListGroupEAM();
      setListSegments(resp.response || []);
      setSegmentsLoaded(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSegments(false);
    }
  };

  const handleSecureChecks = (e) => {
  const { id, checked } = e.target;

  // Se actualiza el objeto complejo policy 
  setPolicy(prev => ({
    ...prev,
    deny: {
      ...prev.deny,
      [id]: checked
    }
  }));

  // Actualizamos los estados individuales para la UI
  if (id === "severity") setSeverity(checked);
  if (id === "locked") setLocked(checked);
  if (id === "reportview") setReportView(checked);
};
  const handleEnableDisableUser = async () => {
    setIsLoading({ ...isLoading, enableDisable: true });
    try {
      await userEnableDisable(
        isActive ? "disable" : "enable",
        email
      );
      setIsActive(!isActive);
    } catch (error) {
      enqueueSnackbar("Error al actualizar el usuario", { variant: "error" });
    }
    setIsLoading({ ...isLoading, enableDisable: false });
  };

  const selectStatus = (value) => {
    const cleanedList = value.filter(
      (item) => item !== null && item !== undefined
    );
    setSelectedStatus(cleanedList);

    const rewrite_policy = { ...policy };
    rewrite_policy.deny.status = cleanedList;
    setPolicy(rewrite_policy);
  };

    const saveSetting = async () => {
    let finalPolicy = {
      ...policy,
      deny: {
        ...policy.deny,
        // Usamos directamente los estados de la UI que son los más nuevos
        status: selectedStatus.filter(s => s).map(s => s.value),
        tags: selectedTags.filter(t => t).map(t => t.key),
        locked: locked,
        severity: severity,
        reportview: reportView
      }
    };

    try {
      const resp = await updateUserAdvanceOptions({
        user_id: userId,
        policy: finalPolicy,
      });

      if (!resp?.error) {
        // // updateUserOnStore();
        // enqueueSnackbar(t("User.user_updated_success"), { variant: "success" });
        navigate("/users", { replace: true });
      }
    } catch (error) {
      enqueueSnackbar(t("User.error_updating"), { variant: "error" });
    }
  };

    const listStatusDict = {
    new: {
      label: t("status.new"),
      value: "new",
    },
    pending: {
      label: t("status.attention_pending"),
      value: "pending",
    },
    process: {
      label: t("status.under_investigation"),
      value: "process",
    },
    finish: {
      label: t("status.in_resolution"),
      value: "finish",
    },
    closed: {
      label: t("status.closed"),
      value: "closed",
    },
    draft: {
      label: t("status.draft"),
      value: "draft",
    },
  };

  const handleEmailChange = (newEmail) => {
    setEmail(newEmail);

    // Replace special characters with '_'
    // Assuming special characters are anything other than letters, numbers, and underscores
    const transformedUsername = newEmail.replace(/[^a-zA-Z0-9]/g, "_");
    setUsername(transformedUsername);
  };

  const getSegmentById = (id) => {
    if (listSegments.length > 0) {
      const segmentToAdd = listSegments.find((segment) => segment.id === id);
      return segmentToAdd?.segment || {};
    }
    return {};
  };

  const getSegmentLabelById = (id) => {
    if (listSegments.length > 0) {
      const segmentToAdd = listSegments.find((segment) => segment.id === id);
      return segmentToAdd?.name || "";
    }
    return "";
  };

  const handleDeleteSegment = async (id) => {
    const newGroupSegments = groupSegment.filter((item) => item !== id);
    try {
      await userInsertInToGroup({
        user_id: userId,
        group_list: newGroupSegments,
      });
      setGroupSegment(newGroupSegments);
    } catch (error) {}
  };

  const listStatus = [
    {
      label: t("status.new"),
      value: "new",
      color: theme.palette.blue.main,
    },
    {
      label: t("status.attention_pending"),
      value: "pending",
      color: theme.palette.purple.main,
    },
    {
      label: t("status.under_investigation"),
      value: "process",
      color: theme.palette.green.main,
    },
    {
      label: t("status.in_resolution"),
      value: "finish",
      color: theme.palette.yellow.main,
    },
    {
      label: t("status.closed"),
      value: "closed",
      color: theme.palette.red.main,
    },
    {
      label: t("status.draft"),
      value: "draft",
      color: theme.palette.blueGray500.main,
    },
  ];

  const breadcrumbItems = [
    { label: t("User.home"), route: "/" },
    { label: t("User.users"), route: "/users" },
    { label: `${isExistingUser ? t("User.edit_user") : t("User.add_user")}` },
  ];

  return (
    <>
      <div id="settings" className="user-page page">
        {isExistingUser ? (
          <GeneralIconHeader
            title={t("User.edit_user")}
            text={t("User.configure_user_roles_permissions")}
            icon="outline_user_edit"
          />
        ) : (
          <GeneralIconHeader
            title={t("User.add_user")}
            text={t("User.configure_user_roles_permissions")}
            icon="outline_user_add"
          />
        )}
        <Breadcrum items={breadcrumbItems} />
        <div className="d-block d-lg-flex mt-3">
          <div className="profile-first-block">
            {/* Layout condicional según modo edición o nuevo usuario */}
            {isExistingUser ? (
              <>
                {/* Modo edición: información personal ocupa todo el ancho */}
                <main className="dyTheme1 dyBorder1 rounded p-4">
                  <h5 className="mb-20">{t("User.personal_information")}</h5>
                  <Row>
                    <Col md="6">
                      <div className="form-group mb-20 w-100 mr-5">
                        <label className="mb-2">{t("User.name")}:</label>
                        <Typography style={{ color: '#5F7782', fontWeight: 400 }}>
                          {first_name}
                        </Typography>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group mb-20 w-100">
                        <label className="mb-2">{t("User.lastname")}:</label>
                        <Typography style={{ color: '#5F7782', fontWeight: 400 }}>{last_name}</Typography>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <div className="form-group mb-20 w-100 mr-5" style={{ overflow: 'hidden'}}>
                        <label className="mb-2">Email:</label>
                        <Typography
                          noWrap
                          title={email}
                          style={{
                            color: '#5F7782',
                            fontWeight: 400,
                            display: 'block',
                            maxWidth: '100%'
                          }}
                        >
                          {email}
                        </Typography>
                      </div>
                    </Col>
                    <Col md="6" style={{ display: 'none' }}>
                      <div className="form-group mb-20 w-100">
                        <label className="mb-2">{t("User.username")}:</label>
                        <Typography
                          noWrap
                          title={username}
                          style={{
                            color: '#5F7782',
                            fontWeight: 400,
                            display: 'block',
                            maxWidth: '100%'
                          }}
                        >
                          {username}
                        </Typography>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <div className="form-group mb-0 w-100">
                        <label>{t("User.phone")}:</label>
                        <Typography style={{ color: '#5F7782', fontWeight: 400 }}>
                          {!phone_number ? "-" : phone_number}
                        </Typography>
                      </div>
                    </Col>
                  </Row>
                </main>

                {/* Sección de permisos en modo edición */}
                <SecurityInformationSection
                  email={email}
                  confirmPassword={confirmPassword}
                  setConfirmPassword={setConfirmPassword}
                  password={password}
                  setPassword={setPassword}
                  isExistingUser={isExistingUser}
                  strength={strength}
                  requirements={requirements}
                />
              </>
            ) : (
              <>
                {/* Modo nuevo usuario */}
                <Row>
                  <Col lg="6" className="mb-4 mb-lg-0">
                    <main className="dyTheme1 dyBorder1 rounded p-4 h-100">
                      <h5 className="mb-20">{t("User.personal_information")}</h5>
                      <Row>
                        <Col md="6">
                          <div className="form-group mb-20 w-100 mr-5">
                            <EGInput
                              type="text"
                              label={t("User.name")}
                              value={first_name}
                              onChange={(e) => setFirst_name(e.target.value)}
                              required
                            />
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group mb-20 w-100">
                            <EGInput
                              type="text"
                              label={t("User.lastname")}
                              value={last_name}
                              onChange={(e) => setLast_name(e.target.value)}
                              required
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="form-group mb-20 w-100 mr-5">
                            <EGInput
                              label="Email"
                              value={email}
                              onChange={(e) => handleEmailChange(e.target.value)}
                              required
                            />
                            {/* Validación visual del email */}
                        {!isExistingUser && email.length > 0 && (
                          <Box sx={{ mt: 0.5, px: 1 }}>
                            <Chip
                              label={
                                <Typography
                                  variant="caption"
                                  fontSize={12}
                                  fontWeight={600}
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  {validateEmail(email) ? t("User.valid_email") : t("User.invalid_email")}
                                </Typography>
                              }
                              size="small"
                              sx={{
                                backgroundColor: alpha(
                                  validateEmail(email) ? "#4caf50" : "#f44336",
                                  0.15
                                ),
                                color: validateEmail(email) ? "success.main" : "error.main",
                                height: 28,
                                px: 0.5,
                              }}
                            />
                          </Box>
                        )}
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group mb-20 w-100">
                            <EGInput
                              label={t("User.confirm_email")}
                              value={confirmEmail}
                              onChange={(e) => setConfirmEmail(e.target.value)}
                              required
                            />
                          </div>
                          <input type="hidden" value={username} />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="form-group mb-30 w-100">
                            <EGInput
                              label={t("User.phone")}
                              value={phone_number}
                              onChange={(e) => setPhone_number(e.target.value)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </main>
                  </Col>
                  <Col lg="6">
                    <SecurityInformationSection
                      email={email}
                      confirmPassword={confirmPassword}
                      setConfirmPassword={setConfirmPassword}
                      password={password}
                      setPassword={setPassword}
                      isExistingUser={isExistingUser}
                      strength={strength}
                      requirements={requirements}
                    />
                  </Col>
                </Row>
              </>
            )}

            {/* Add permissions section */}
            {isExistingUser && (
              <>
                <section className="dyTheme1 dyBorder1 rounded mt-4 p-4">
                  <AddSegment
                    userId={userId}
                    segmentList={listSegments}
                    currentSegments={groupSegment}
                    setGroupSegment={setGroupSegment}
                    onLoadSegments={loadSegments}
                  />
                </section>

                <section className="dyTheme1 dyBorder1 rounded mt-4 p-4">
                  <AssignRole userId={userId} currentRole={role} />
                </section>

                <section className="dyTheme1 dyBorder1 rounded mt-4 p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>{t("User.advanced_options")}</h5>
                    <span
                      onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                      style={{ cursor: 'pointer', color: '#009ED7', fontSize: '0.8rem' }}
                    >
                      {showAdvancedOptions ? t("User.show_less") : t("User.show_more")}
                    </span>
                  </div>

                  {showAdvancedOptions && (
                    <>
                  <Row className="mt-4">
                    <Col md="9">
                      <div className="form-group mb-30 w-100 mr-5">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <small>{t("User.can_see_locked")}</small>
                          <FormCheck
                            id="locked"
                            type="switch"
                            checked={locked}
                            onChange={handleSecureChecks}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="9">
                      <div className="form-group mb-30 w-100 mr-5">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <small>{t("User.can_see_high_severity")}</small>
                          <FormCheck
                            id="severity"
                            type="switch"
                            checked={severity}
                            onChange={handleSecureChecks}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="9">
                      <div className="form-group mb-30 w-100 mr-5">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <small>{t("User.can_see_report_details")}</small>
                          <FormCheck
                            id="reportview"
                            type="switch"
                            checked={reportView}
                            onChange={handleSecureChecks}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <div className="form-group mb-30 w-100 mr-5">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <small></small>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <Box sx={{ width: "100%" }}>
                            <Autocomplete
                              multiple
                              options={indicatorTags}
                              getOptionLabel={(option) => option.label}
                              value={selectedTags}
                              onChange={(_, newValue) =>
                                handleTagsChange(newValue)
                              }
                              disableCloseOnSelect
                              renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <Box
                                    key={option.key}
                                    {...optionProps}
                                    sx={{
                                      maxHeight: { xs: 35, md: 40 },
                                      p: 1,
                                      mx: 1,
                                      borderRadius: 1.5,
                                      border: `${theme.palette.blueGray50.main} 1px solid`,
                                    }}
                                  >
                                    <EGCheckbox
                                      size="small"
                                      checked={selected}
                                      color="primary"
                                    />
                                    <BoldFlag
                                      size={20}
                                      color={theme.palette[option.color].main}
                                    />
                                    <Typography variant="body1" mx={1}>
                                      {option.label}
                                    </Typography>
                                  </Box>
                                );
                              }}
                              renderInput={(params) => (
                                <EGInput
                                  {...params}
                                  label={`${t("User.select_tags_block")}:`}
                                />
                              )}
                              renderTags={(tagValue, getTagProps) => (
                                <Box
                                  sx={{
                                    maxHeight: { xs: "15vh", md: "20vh" },
                                    minHeight: "30px",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    mr: 1,
                                    my: 0.33,
                                    gap: 0.3,
                                    pointerEvents: "none",
                                  }}
                                >
                                  {tagValue.length > 0
                                    ? tagValue.map((option, index) => (
                                        <Chip
                                          {...getTagProps({ index })}
                                          key={option.label}
                                          sx={{
                                            backgroundColor: alpha(
                                              theme.palette[option.color].main,
                                              0.1
                                            ),
                                            fontSize: { xs: 7, md: 10 },
                                            px: { xs: 0, md: 0.5 },
                                            mr: 2,
                                            pointerEvents: "auto",
                                          }}
                                          label={
                                            <Typography
                                              variant="body1"
                                              mx={{ xs: 0.5, md: 1 }}
                                            >
                                              {option.label}
                                            </Typography>
                                          }
                                          size={esXs ? "small" : "medium"}
                                          icon={
                                            <BoldFlag
                                              size={18}
                                              color={
                                                theme.palette[option.color].main
                                              }
                                            />
                                          }
                                        />
                                      ))
                                    : null}
                                </Box>
                              )}
                            />
                          </Box>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <div className="form-group mb-30 w-100 mr-5">
                        <Box sx={{ width: "100%" }}>
                          <Autocomplete
                            multiple
                            options={listStatus}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            value={selectedStatus}
                            onChange={(_, newValue) => selectStatus(newValue)}
                            disableCloseOnSelect
                            slotProps={{
                              popper: { placement: 'top' }
                            }}
                            renderOption={(props, option, { selected }) => {
                              const { key, ...optionProps } = props;
                              return (
                                <Box
                                  key={option.value}
                                  {...optionProps}
                                  sx={{
                                    maxHeight: { xs: 35, md: 40 },
                                    p: 1,
                                    mx: 1,
                                    borderRadius: 1.5,
                                    border: `${theme.palette.blueGray50.main} 1px solid`,
                                  }}
                                >
                                  <EGCheckbox
                                    size="small"
                                    checked={selected}
                                    color="primary"
                                  />
                                  <Box
                                    sx={{
                                      width: 12,
                                      height: 12,
                                      borderRadius: '50%',
                                      backgroundColor: option.color,
                                      ml: 1,
                                    }}
                                  />
                                  <Typography variant="body1" mx={1}>
                                    {option.label}
                                  </Typography>
                                </Box>
                              );
                            }}
                            renderInput={(params) => (
                              <EGInput
                                {...params}
                                label={`${t("User.lock_status")}:`}
                              />
                            )}
                            renderTags={(tagValue, getTagProps) => (
                              <Box
                                sx={{
                                  maxHeight: { xs: "15vh", md: "20vh" },
                                  minHeight: "30px",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                  mr: 1,
                                  my: 0.33,
                                  gap: 0.3,
                                  pointerEvents: "none",
                                }}
                              >
                                {tagValue.length > 0
                                  ? tagValue.map((option, index) => {
                                    if (!option || !option.value) return null;
                                      const statusColor = listStatus.find(s => s?.value === option.value)?.color || theme.palette.blueGray500.main;
                                      return (
                                        <Chip
                                          {...getTagProps({ index })}
                                          key={option.value}
                                          sx={{
                                            backgroundColor: alpha(statusColor, 0.15),
                                            fontSize: { xs: 7, md: 10 },
                                            px: { xs: 0, md: 0.5 },
                                            mr: 2,
                                            pointerEvents: "auto",
                                          }}
                                          label={
                                            <Typography
                                              variant="body1"
                                              mx={{ xs: 0.5, md: 1 }}
                                            >
                                              {option.label}
                                            </Typography>
                                          }
                                          size={esXs ? "small" : "medium"}
                                          icon={
                                            <Box
                                              sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: '50%',
                                                backgroundColor: statusColor,
                                                ml: 1,
                                              }}
                                            />
                                          }
                                        />
                                      );
                                    })
                                  : null}
                              </Box>
                            )}
                          />
                        </Box>
                      </div>
                    </Col>
                  </Row>
                  

                  <MCButton
                    label={t("User.save_configuration")}
                    variant="primary"
                    onClick={() => saveSetting()}
                  />         
                  </>
                  )}                
                  {/* <pre>{JSON.stringify(policy, null, 2)}</pre>  */}
              
                </section>
              </>
            )}
            

            {!isExistingUser && (
              <section className="user-button mt-4">
                <Row>
                  <Col className="d-flex justify-content-end">
                    <MCButton
                      className="mt-0"
                      label={t("User.add_user")}
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                    />
                  </Col>
                </Row>
              </section>
            )}
          </div>

          {isExistingUser && (
            <div className="dyTheme1 dyBorder1 rounded profile-second-block p-20 user-second-bar">
              <h5 className="mb-20 text-left">
                {t("User.report_acces_filter")}
              </h5>
              {isExistingUser ? (
                <small className="pb-3 border-bottom">
                  {t("User.assign_permissions_user")}
                </small>
              ) : (
                <small className="pb-3 border-bottom">
                  {t("User.enter_permissions_user")}
                </small>
              )}
              <div className="d-flex flex-column p-20">
                <img
                  src={Permis}
                  alt="permission"
                  className="d-block mx-auto"
                />
              </div>

              <aside>
                {isExistingUser && (
                  <>
                    <div className="segment-user">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>{t("User.user_segment")}</h5>
                      <span
                        onClick={async () => {
                          if (!showSegmentUser) await loadSegments();
                          setShowSegmentUser(!showSegmentUser);
                        }}
                        style={{ cursor: 'pointer', color: '#009ED7', fontSize: '0.8rem' }}
                      >
                        {loadingSegments ? t("User.loading") : showSegmentUser ? t("User.show_less") : t("User.show_more")}
                      </span>
                    </div>

                      {/* <MCButton
                          label={t("user.add_filter_user")}
                          variant="primary"
                          outline
                          onClick={() =>
                          navigate(`/segments/new/`, { state: { userv } })
                        } /> */}
                    {showSegmentUser && (
                    <div className="mt-2 animate__animated animate__fadeIn">
                      {state?.user?.segment && Object.keys(state.user.segment).length > 0 ? (
                        <Segment segment={state.user.segment} />
                      ) : ( 
                        <span style={{ color: "grey", fontStyle: "italic" }}>
                          {t("Users.no_results")}
                        </span>
                      )}
                    </div>
                    )}
                    </div>

                    <hr />

                    <div className="segment-user">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5>{t("User.group_segment")}</h5>
                        <span
                          onClick={async () => {
                            if (!showSegmentGroup) await loadSegments();
                            setShowSegmentGroup(!showSegmentGroup);
                          }}
                          style={{ cursor: 'pointer', color: '#009ED7', fontSize: '0.8rem' }}
                        >
                          {loadingSegments ? t("User.loading") : showSegmentGroup ? t("User.show_less") : t("User.show_more")}
                        </span>
                      </div>

                      {showSegmentGroup && (
                        <div className="mt-2 animate__animated animate__fadeIn">
                          {loadingSegments ? (
                            <span style={{ color: "grey", fontStyle: "italic" }}>
                              {t("User.loading")}
                            </span>
                          ) : groupSegment && groupSegment.length > 0 ? (
                            groupSegment.map((groupId) => (
                              <div key={groupId} className="mb-3">
                                <div className="d-flex justify-content-between">
                                  <h6>
                                    --{getSegmentLabelById(groupId)}--
                                    <span
                                      onClick={() => handleDeleteSegment(groupId)}
                                      style={{ color: "red", cursor: "pointer", marginLeft: '10px' }}
                                    >
                                      x
                                    </span>
                                  </h6>
                                </div>
                                <Segment segment={getSegmentById(groupId)} />
                              </div>
                            ))
                          ) : (
                            <div className="py-2">
                              <span style={{ color: "grey", fontStyle: "italic" }}>
                                {t("Users.no_results")}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

               {/* ENABLE / DISABLE USER */}
                <section className="mt-4">
                  <Row>
                      <MCButton
                        className="mt-0 pointer"
                        label={!isActive ? t("Users.enable") : t("Users.disable")}
                        variant={!isActive ? "success" : "danger"}
                        type="submit"
                        onClick={handleEnableDisableUser}
                        disabled={isLoading.enableDisable}
                      />
                  </Row>
                </section>
                  </>
                )}
              </aside>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
